module.exports = __webpack_public_path__ + "8dbc6d22dad8839dde738e1e8f4b195c.svg";